import classNames from "classnames";
import Button from "components/core/Button/Button";
import React, { useState } from "react";
import styles from "./RecentlyClaimedPerkCard.module.scss";
import Clock from "public/icons/clock.svg";

type Props = {
  className?: string;
} & (
  | {
      isLoading: true;
    }
  | {
      isLoading?: false;
      logoUrl: string;
      backgroundColor?: string;
      perkImageUrl: string;
      title: string;
      tickerSymbol: string;
      buttonText?: string;
      onClick: () => void;
      availableToClaim?: boolean;
      alreadyClaimed?: boolean;
      sharesUntil?: number;
      recurringDays?: number;
      notQualifiedText?: string;
    }
);

const RecentlyClaimedPerkCard = (props: Props) => {
  if (props.isLoading) {
    return <div className={classNames(styles.card, styles.card_Loading)}></div>;
  }

  return (
    <div
      onClick={props.onClick}
      className={classNames(styles.card, props.className)}
      data-cy="RecentlyClaimedPerkCard"
    >
      <div className={styles.container}>
        <img src={props.logoUrl} className={styles.logo} />
        <h4 className={styles.title}>{props.title}</h4>
        <Button type="inline" arrow noAnimate className={styles.button} noATag>
          {props.buttonText || "View Details"}
        </Button>
      </div>
      <div
        className={styles.image}
        style={{
          backgroundColor: props.backgroundColor || "#000",
          opacity: 0.5,
          zIndex: 1,
        }}
      />
      <img src={props.perkImageUrl} className={styles.image} />
      {props.availableToClaim && (
        <div className={styles.availableToClaim}>Available to Claim</div>
      )}
      {props.alreadyClaimed &&
        !props.availableToClaim &&
        !props.recurringDays && (
          <div className={styles.alreadyClaimedContainer}>Already Claimed</div>
        )}
      {props.recurringDays && !props.availableToClaim && (
        <div className={styles.alreadyClaimedContainer}>
          <Clock className={styles.clock} /> Claim again in{" "}
          {props.recurringDays} Days
        </div>
      )}
      {props.notQualifiedText &&
        !props.alreadyClaimed &&
        !props.availableToClaim &&
        !props.recurringDays && (
          <div className={styles.alreadyClaimedContainer}>
            {props.notQualifiedText}
          </div>
        )}
    </div>
  );
};

export default RecentlyClaimedPerkCard;
